module.exports = __webpack_public_path__ + "img/programs_horizontal.8aba2f6a.png";